import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/admin/admin.service';

interface DialogData {

}


@Component({
  selector: 'app-reject-po',
  templateUrl: './reject-po.component.html',
  styleUrls: ['./reject-po.component.scss']
})
export class RejectPoComponent implements OnInit {

  reasonList;
  rowData;
  otherReasons: boolean;
  rejectionId = [];
  inputValue;
  rejectionIdArray: [] = []

  constructor(
    public dialogref: MatDialogRef<RejectPoComponent>,
    private adminService: AdminService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.rowData = this.data["data"];
    console.log(this.rowData)
    this.getrejectionList();
    this.otherReasons = false;
    this.toastr.info('You are about to reject a PO', 'info');
  }

  getrejectionList() {
    this.adminService.getRejectReasonList().subscribe(
      (res: any) => {
        this.reasonList = res.body;
      }
    )
  }

  radioChange(event) {

    let details: any = this.reasonList[parseInt(event.source.value)];
    let index = this.rejectionId.indexOf(details)

    if (event.checked == true) {
      this.rejectionId.push(details.id);
    }
    else if (event.checked == false) {
      this.rejectionId.splice(index, 1);
    }

    // console.log(this.rejectionId)   
  }

  inputField(event) {
    console.log(event)
    this.inputValue = event;
  }

  submit() {
    let form = {
      "vendor_order": {
        "rejection_note": this.inputValue,
        "vendor_order_rejection_reasons_attributes": [{
          "rejection_reason_id": this.rejectionId
        }]
      }
    }

    console.log(form)
    this.adminService.rejectPurchaseOrder(this.rowData.id, form).subscribe(
      res => {
        console.log(res)
        this.close();
        this.toastr.success('Successfully rejected the Purchase Order', 'Success');
      },
      err => {
        console.log(err)
        this.toastr.error('Something went wrong', 'error');
        this.close();
      }
    )

    // for (var i = 0; i < this.rejectionId.length; i++) {
    //   // console.log(form.vendor_order.rejection_note.vendor_order_rejection_reasons_attributes.push("rejection_reason_id", this.rejectionId[i]))
    //   this.rejectionIdArray.push(note, this.rejectionId[i])
    // }

  }

  close() {
    this.dialogref.close()
  }

}
